import { ComponentPropsWithoutRef } from 'react';
import * as Skeleton from '@givebutter/primitives/skeleton';
import { NucleoIcon, NucleoIconProps } from 'components/nucleo-icon';
import * as SidebarLink from 'components/sidebar/SidebarLink';
import { useResponsive } from 'contexts/useResponsive';
import { twMerge } from 'tailwind-merge';

const PrimaryLinksFallback = () => (
    <SidebarLink.Group>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="house" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="bullhorn" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <div className="h-[0.78rem] w-[1.125rem]" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="receipt" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="users" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="envelope" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="circleDollar" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
        <PrimaryLinkFallbackContainer>
            <PrimaryLinkFallbackIcon icon="gear" />
            <PrimaryLinkFallbackSkeletonBar />
        </PrimaryLinkFallbackContainer>
    </SidebarLink.Group>
);

interface PrimaryLinkFallbackContainerProps extends ComponentPropsWithoutRef<'div'> {}

const PrimaryLinkFallbackContainer = (props: PrimaryLinkFallbackContainerProps) => {
    const { children, className = '', ...rest } = props;
    return (
        <div className={twMerge('flex items-center gap-3 p-2 px-3', className)} {...rest}>
            {children}
        </div>
    );
};

interface PrimaryLinkFallbackIconProps extends NucleoIconProps {}

const PrimaryLinkFallbackIcon = (props: PrimaryLinkFallbackIconProps) => {
    const { icon, className = '', ...rest } = props;
    return <NucleoIcon icon={icon} className={twMerge('text-gray-500', className)} {...rest} />;
};

interface PrimaryLinkFallbackSkeletonBarProps extends Skeleton.SkeletonBarProps {}

const PrimaryLinkFallbackSkeletonBar = (props: PrimaryLinkFallbackSkeletonBarProps) => {
    const { className = '', ...rest } = props;
    const isCollapsed = useResponsive(state => state.isSidebarCollapsed);

    return (
        <Skeleton.Bar
            className={twMerge('!h-1.5 !bg-gray-300', isCollapsed && 'hidden', className)}
            {...rest}
        />
    );
};

export { PrimaryLinksFallback };
